import React, { useState, useEffect } from 'react';
import { API, getToken } from './adminApi';

const NewSignupsTab = () => {
  const [signups, setSignups] = useState(null);
  const [signupsLoading, setSignupsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [enlargedPhoto, setEnlargedPhoto] = useState(null);

  useEffect(() => { fetchSignups(); }, []);

  const fetchSignups = async () => {
    setSignupsLoading(true);
    try {
      const token = await getToken();
      const res = await fetch(`${API}/admin/signups?limit=50`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setSignups(data.signups || []);
    } catch (err) {
      setFetchError(err.message);
    } finally {
      setSignupsLoading(false);
    }
  };

  return (
    <div className="as-signups">
      {fetchError && <div className="as-error">{fetchError}</div>}
      <div className="as-activity-toolbar">
        <button className="as-filter-tab" onClick={fetchSignups}>↻ Refresh</button>
      </div>

      {signupsLoading && <div className="as-loading">Loading…</div>}

      {signups && (
        <>
          <h2 className="as-section-title">🆕 New Signups ({signups.length})</h2>
          {signups.length === 0 && <div className="as-empty">No signups yet.</div>}
          <div className="as-signup-list">
            {signups.map(s => (
              <div key={s.userId} className="as-signup-card">
                <div className="as-signup-photo-gallery">
                  {s.pics && s.pics.length > 0 ? (
                    s.pics.map((pic, i) => (
                      <img
                        key={i}
                        src={pic}
                        alt=""
                        className="as-signup-img as-signup-img--clickable"
                        onClick={() => setEnlargedPhoto(pic)}
                      />
                    ))
                  ) : (
                    <div className="as-signup-img-placeholder">?</div>
                  )}
                </div>
                <div className="as-signup-details">
                  {s.gender && <div className="as-signup-gender">{s.gender}</div>}
                  <div className="as-signup-headline">
                    <strong>{s.firstName || '(no name)'}</strong>
                    {s.age != null && <span className="as-signup-age">{s.age}</span>}
                  </div>
                  <div className="as-card-meta">
                    {s.localArea || 'Location not set'} · {new Date(s.signupAt).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </div>
                  <div className="as-card-meta as-card-meta--id">ID: {s.userId}</div>

                  {s.communities.length === 0 && (
                    <div className="as-signup-community as-signup-community--empty">No community joined yet</div>
                  )}
                  {s.communities.map(c => (
                    <div key={c.communityId} className="as-signup-community">
                      <div className="as-signup-community-title">{c.communityTitle}</div>
                      {c.profile ? (
                        <div className="as-signup-profile-fields">
                          {Object.entries(c.profile).map(([field, value]) => {
                            if (value === '' || value == null || (Array.isArray(value) && value.length === 0)) return null;
                            return (
                              <div key={field} className="as-signup-profile-field">
                                <span className="as-signup-field-name">{field}:</span>{' '}
                                <span>{Array.isArray(value) ? value.join(', ') : String(value)}</span>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <div className="as-signup-profile-field as-signup-profile-field--empty">No community profile filled in yet</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {enlargedPhoto && (
        <div className="as-photo-overlay" onClick={() => setEnlargedPhoto(null)}>
          <img src={enlargedPhoto} alt="" className="as-photo-overlay-img" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
};

export default NewSignupsTab;
